import '@polymer/paper-button/paper-button';
import '../../../../neb-lit-components/src/components/neb-button';

import { html, css, LitElement } from 'lit';

import { toPhoneDisplayValue } from '../../../../neb-input/nebFormatUtils';
import { renderNebButtonStyles } from '../../../../neb-styles/neb-button-styles';
import { CSS_SPACING } from '../../../../neb-styles/neb-variables';

export const ELEMENTS = {
  name: { id: 'login-name' },
  phoneNumber: { id: 'phone-number' },
  bookingButton: { id: 'booking-button' },
};

export const TEXT_SCHEDULE = 'BOOK MY APPOINTMENT';
export const TEXT_RESCHEDULE = 'RESCHEDULE MY APPOINTMENT';

const countryCodePattern = /^\+1|\|1|\D/;

class NebReviewLoginDetail extends LitElement {
  static get properties() {
    return {
      __appointmentCreateError: Object,

      isReschedule: Boolean,
      user: Object,
    };
  }

  static get styles() {
    return css`
      .login-detail {
        display: flex;
        flex-direction: column;
        margin-top: ${CSS_SPACING};
      }

      .book-action {
        margin-top: ${CSS_SPACING};
      }
    `;
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.isReschedule = false;
    this.user = {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      clientId: '',
    };

    this.onBook = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      bookAppointment: () => {
        this.onBook();
      },
    };
  }

  __computePhoneNumber(phoneNumber) {
    return toPhoneDisplayValue(phoneNumber.replace(countryCodePattern, ''));
  }

  render() {
    return html`
      ${renderNebButtonStyles()}

      <div id="loginDetail" class="login-detail">
        <span id="${ELEMENTS.name.id}">
          ${this.user.firstName} ${this.user.lastName}
        </span>

        <span id="${ELEMENTS.phoneNumber.id}">
          ${this.__computePhoneNumber(this.user.phoneNumber)}
        </span>

        <span id="loginclientId"> ${this.user.clientId} </span>
      </div>

      <div class="book-action">
        <neb-button
          id="${ELEMENTS.bookingButton.id}"
          .onClick="${this.__handlers.bookAppointment}"
          .label="${this.isReschedule ? TEXT_RESCHEDULE : TEXT_SCHEDULE}"
        ></neb-button>
      </div>
    `;
  }
}

customElements.define('neb-review-login-detail', NebReviewLoginDetail);
